export interface AlertDialogData {
  message: string,
  subMessage: string,
}

export interface AlertDialogResult {

}


export interface ConfirmationDialogData {
  message: string,
  subMessage: string,
  /** Overrides the confirm button's default 'Confirm' label. */
  confirmLabel?: string,
  /** Overrides the dismiss button's default 'Close' label. */
  cancelLabel?: string,
  /** Centres the subMessage body copy, which is left aligned by default. */
  centeredText?: boolean,
}

export interface ConfirmationDialogResult {
  readyForSubmission: boolean;
}

// Also used by the admin "Mark Consent Complete" bypass, which needs the same mandatory-reason
// capture under different copy. Unset fields fall back to the resend-a-signed-form wording.
export interface ResendSignedConsentDialogData {
  name: string;
  title?: string;
  warning?: string;
  submitLabel?: string;
}

export interface ResendSignedConsentDialogResult {
  readyForSubmission: boolean;
  reason: string;
}


// Distinguishes officer-decidable side effects so the confirmation dialog can tailor intro / skip copy.
export type SaveConfirmationActionKind = 'consentIssue' | 'consentReissue' | 'reverify' | 'creditFlowRun';

// One side effect a save will trigger. Skippable actions render as an opt-out checkbox (internal
// officers only); the ids of unticked actions come back in SaveConfirmationDialogResult.skippedActionIds.
export interface SaveConfirmationAction {
  id: string,
  label: string,
  skippable: boolean,
  kind?: SaveConfirmationActionKind,
}

// A single party (individual) and the human-readable actions that saving will trigger for them.
export interface SaveConfirmationConsequence {
  name: string,
  // Optional lead-in rendered under the name (e.g. why these actions are grouped together).
  note?: string,
  actions: SaveConfirmationAction[],
}

export interface SaveConfirmationDialogData {
  title?: string,
  message?: string,
  consequences: SaveConfirmationConsequence[],
}

export interface SaveConfirmationDialogResult {
  readyForSubmission: boolean;
  // Ids of the skippable actions the officer opted out of; absent/empty means everything proceeds.
  skippedActionIds?: string[];
}


export interface YesNoDialogData {
  message: string,
  subMessage: string,
}

export interface YesNoDialogResult {
  readyForSubmission: boolean;
}